import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { firstAllowedRoute, hasModule } from "@/lib/auth";
import { ScannerLoginsClient } from "@/features/warehouse/ScannerLoginsClient";
import { listScannerLogins, scannerLoginKeys } from "@/features/warehouse/scannerLogins.api";

// Warehouse → Scannergebruikers (docs/auth.md §2a): the scanner logins of the floor without Entra,
// for the team leader with wms_scanner_logins — and on the API regardless.
export const Route = createFileRoute("/_shell/warehouse/scanner-users")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "wms_scanner_logins")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: ScannerUsersScreen,
});

function ScannerUsersScreen() {
  const { session } = Route.useRouteContext();
  const query = useQuery({ queryKey: scannerLoginKeys.all, queryFn: listScannerLogins });
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Warehouse Scanner Users">
      <ScannerLoginsClient
        logins={query.data?.logins ?? []}
        roles={query.data?.roles ?? []}
        userId={session.userId}
        isAdmin={session.roles.includes("admin")}
        isLoading={query.isLoading}
      />
    </div>
  );
}
